import React from 'react';

const GalleryCarousel = ({ title, icon, items }) => {
  return (
    <div className="mb-10">
      <h4 className="font-semibold text-base sm:text-lg text-premium-dark mb-3 sm:mb-4 flex items-center">
        <i className={`fa-solid ${icon} text-premium-gold mr-2`}></i>
        {title}
      </h4>
      <div className="relative">
        <div className="overflow-x-auto scrollbar-hide">
          <div className="flex gap-4 pb-2">
            {items.map((item, index) => (
              <div
                key={index}
                className="h-48 flex-shrink-0 overflow-hidden bg-premium-light cursor-pointer hover:opacity-80 transition-opacity group relative flex items-center justify-center"
              >
                <img
                  src={item.image}
                  alt={item.alt}
                  className="h-full w-auto object-contain"
                />
                {item.label && (
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-premium-dark/90 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="text-white font-medium text-sm">{item.label}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-16 h-full bg-gradient-to-l from-white via-white/50 to-transparent pointer-events-none"></div>
      </div>
    </div>
  );
};

const CustomOptionsGallery = ({ sections }) => {
  return (
    <div id="thumbnail-gallery-section">
      <h3 className="font-bold text-xl sm:text-2xl text-premium-dark mb-4 sm:mb-6">Custom Options</h3>
      
      {(sections || []).map((section, idx) => (
        <GalleryCarousel
          key={`${section.title}-${idx}`}
          title={section.title}
          icon={section.icon}
          items={section.items}
        />
      ))}
    </div>
  );
};

export default CustomOptionsGallery;
